import {
  AutocompleteArrayInput,
  BooleanInput,
  ReferenceArrayInput,
} from "react-admin";
import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";

const DriversInput = () => {
  const notificationTargetTypeField = useField("notificationTargetType");
  const routeInput = useField("routeIds");
  const schoolInput = useField("schoolId");
  const busScheduleInput = useField("busScheduleIds");

  const isSendToAllField = useField("isSendToAllDrivers");
  const driverIdsField = useField("driverIds");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  useEffect(() => {
    if (isSendToAllField.input.value) {
      setIsDisabled(true);
      driverIdsField.input.onChange([]);
    } else {
      setIsDisabled(false);
      driverIdsField.input.onChange([]);
    }
  }, [isSendToAllField.input.value]);

  const filter = (targetType: string) => {
    let filter;
    switch (targetType) {
      case "school":
        filter = { 
          ActiveAssignmentSchoolId: Number(schoolInput.input.value),
          Type: "driver"
        };
        break;
      case "bus_schedule":
        filter = {
          ActiveAssignmentBusScheduleIds: busScheduleInput.input.value,
          Type: "driver"
        };
        break;
      case "route":
        filter = { 
          ActiveAssignmentRouteIds: routeInput.input.value,
          Type: "driver"
        };
        break;
    }

    return filter;
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <>
      <ReferenceArrayInput
        label="Driver"
        source="driverIds"
        reference="listDriversForNotification"
        filter={isFocused ? filter(notificationTargetTypeField.input.value) : {}}
        filterToQuery={(searchText: string) => {
          if (searchText !== "") return { search: searchText };
        }}
        sort={{ field: "name", order: "ASC" }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={isDisabled}
      >
        <AutocompleteArrayInput optionText="fullName" debounce={1000} />
      </ReferenceArrayInput>
      <BooleanInput label="Send To All Drivers" source="isSendToAllDrivers" />
    </>
  );
};

export default DriversInput;
